<template>
  <Row class-name="bodys" :style="{ 'min-height': `${$store.state.init.offsetHeight - 251}px` }">
    <Col span="24">
      <BreadcrumbWrap />
      <p class="title">{{ title }}</p>
      <TableAndPage
        :columns="columns"
        :api="api"
        :searchQuery="searchQuery"
      />
      <MyDetails ref="myDetails" />
    </Col>
  </Row>
</template>

<script>
import { GetArchSubsPC } from '@api'
import TableAndPage from '@components/tableAndPage'
import MyDetails from './details'
import { formatDay, formatCensorState } from '@libs/enum'
import { localStoragePackage } from '@libs/util'
import BreadcrumbWrap from '@components/breadcrumb-wrap'
export default {
  name: 'record',
  components: { TableAndPage, MyDetails, BreadcrumbWrap },
  data () {
    return {
      title: '个人（单位）查档记录',
      columns: [],
      api: GetArchSubsPC,
    }
  },
  computed: {
    searchQuery () {
      const ticket = localStoragePackage('get', 'ticket')
      return { ticket }
    }
  },
  beforeCreate () {
    this.$route.params.reload && window.location.reload()
  },
  mounted () {
    this.buildColumns()
  },
  methods: {
    buildColumns () {
      const columns = [
        {
          title: '序号',
          type: 'index',
          width: 70,
          align: 'center'
        }, {
          title: '查档单号',
          align: 'center',
          key: 'SubscribeNo'
        }, {
          title: '预约日期',
          align: 'center',
          render: (h, params) => {
            const { SubscribeZQDate, Amorpm } = params.row
            const date = `${SubscribeZQDate || ''} ${formatDay(Amorpm) || '' }`
            return (
              <span>{ date }</span>
            )
          }
        }, {
          title: '审核状态',
          align: 'center',
          render: (h, params) => {
            const { AcceptStatus } = params.row
            return (
              <span>{ formatCensorState(AcceptStatus) }</span>
            )
          }
        }, {
          title: '操作',
          width: 180,
          align: 'center',
          render: (h, { row }) => {
            const { AcceptStatus } = row
            const btn = []
            if (AcceptStatus === '0') {
              btn.push(<Button
                type="info"
                size="small"
                onClick={ () => { this.handleModify(row) } }
              >修改</Button>)
            }
            btn.push(<Button
              type="info"
              size="small"
              onClick={ () => { this.$refs['myDetails'].open(row) } }
            >查看详情</Button>)
            return (
              <div class="btnGroup">{ btn }</div>
            )
          }
        }
      ]
      this.$set(this, 'columns', columns)
    },
    handleModify ({ SID }) {
      this.$router.push({
        name: 'modify-register',
        query: { sid: SID }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@theme/globle.scss';
$md: 768px;
.bodys {
  background: #fff;
  padding: 16px;
  border-top: 2px solid $default;
}
.title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-top: 16px;
  margin-bottom: 16px;
  @media screen and (max-width: $md) {
    font-size: 18px;
  }
}
</style>
